/**
 * @file vuex配置
 */
import Vue from 'vue';
import Vuex from 'vuex';
import zft from './zft';
import env from './env';

Vue.use(Vuex);

export default new Vuex.Store({
    // strict: process.env.NODE_ENV !== 'production',
    modules: {
        env, zft
    }
});
